import React from "react";

import Select from "react-select"
import { GlobalContext } from "../../../../utils/globalprovider.js";
import { apiGetDiffusorsList } from "../../../../utils/apis.js";
import "./combos.css"

class ComboDiff extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super (props);

        this.state = {
            diffusors: [],
            selectedDiffusor: null, 
        }
        this.onGetTableList = this.onGetTableList.bind(this);
    }

    onGetTableList(datas)
    {

    var options = [
        {value:0, label:this.context.language=="fr"?"Non spécifié":"Unspecified"},
    
        ...datas.map(c => ({
            value: c.diid,
            label: c.diname,
            image: c.diimage
            })),
        ]


    var selected = options.find(o => o.value === this.props.diffid);
    if (!selected) 
        selected = options.find(o => o.value === 0);

    this.setState( {
      options: options,
      selectedDiffusor: selected,
    });        
        
    }

    customStyles = {
        container: (base) => ({
        ...base,
        width: "96.2%",
        marginLeft: "1%"
        }),

        control: (base) => ({
        ...base,
        border:  "none",
        boxShadow: "none",
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "30px"
        }),

        singleValue: (base) => ({
        ...base,
        color: "#fff",
        fontSize: "13px"
        }),

        menu: (base) => ({
        ...base,
        backgroundColor: "#000"
        }),

        option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#333" : "#000",
        color: "#fff",
        fontSize: "13px",
        cursor: "pointer"
        }),

        input: (base) => ({
        ...base,
        color: "#fff",
        fontSize: "13px"
        })
    };



    formatOptionLabel = ({ value,label, image }) => {

    const emptyImage =     "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

    return (
                <div style={{ display: "flex", alignItems: "center" }}>
                <img
                    src={image ? image : emptyImage}
                    alt=""
                    style={{
                    width: 20,
                    height: 20,
                    marginRight: 8,
                    objectFit: "cover"
                    }}
                />
                <span>{value===0?"":String(value).padStart(4, " ")} &nbsp; {label}</span>
                </div>
            ) ;
    }
    
    
    handleChange = (selectedOption) => 
        {
    this.setState({ selectedDiffusor: selectedOption });

    if (this.props.onChange)
        this.props.onChange (selectedOption.value);
    };

    componentDidMount()
    {

      apiGetDiffusorsList (this.onGetTableList);
    }

    render()
    {

    return (
                    <Select
                    options={this.state.options}
                    value={this.state.selectedDiffusor}
                    onChange={this.handleChange}
                    formatOptionLabel={this.formatOptionLabel}
                    styles={ this.customStyles}
                    />
    );    
    }
}


ComboDiff.defaultProps = 
{ 
    diffid : -1,
}

export default ComboDiff;
